"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uncontrollable = require("uncontrollable");
var _useEventCallback = _interopRequireDefault(require("@restart/hooks/useEventCallback"));
var _Anchor = _interopRequireDefault(require("@restart/ui/Anchor"));
var _ThemeProvider = require("../../ThemeProvider");
var _Fade = _interopRequireDefault(require("../../Utilities/Transition/Fade"));
var _Icon = require("../../Elements/Icon/Icon");
var _Text = require("../../Elements/Text/Text");
var _CloseButton = _interopRequireDefault(require("../../CloseButton"));
var _divWithClassName = _interopRequireDefault(require("../../divWithClassName"));
var _createWithBsPrefix = _interopRequireDefault(require("../../createWithBsPrefix"));
var _jsxRuntime = require("react/jsx-runtime");
const variantIconMap = {
  error: {
    icon: 'warning-amber',
    color: 'error'
  },
  warning: {
    icon: 'error',
    color: 'warning'
  },
  success: {
    icon: 'check-circle',
    color: 'success'
  },
  info: {
    icon: 'lock',
    color: 'info'
  },
  brand: {
    icon: 'error',
    color: 'brand'
  }
};
// TODO: Are AlertHeading & AlertLink still relevant?
const DivStyledAsH4 = (0, _divWithClassName.default)('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
const AlertHeading = (0, _createWithBsPrefix.default)('alert-heading', {
  Component: DivStyledAsH4
});
const AlertLink = (0, _createWithBsPrefix.default)('alert-link', {
  Component: _Anchor.default
});
const defaultProps = {
  variant: 'warning',
  transition: _Fade.default,
  defaultShow: true,
  closeLabel: 'Close alert',
  onClose: () => undefined
};
const Alert = /*#__PURE__*/_react.default.forwardRef((uncontrolledProps, ref) => {
  const {
    bsPrefix,
    show,
    closeLabel,
    className,
    heading,
    children,
    variant,
    onClose,
    dismissible,
    transition,
    actions,
    timestamp,
    analytics,
    ...props
  } = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
    show: 'onClose'
  });
  const prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'alert');
  const handleClose = (0, _useEventCallback.default)(e => {
    if (onClose) {
      onClose(false, e);
    }
  });
  const Transition = transition === true ? _Fade.default : transition;
  const alert = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "alert",
    ...(!Transition ? props : undefined),
    ref: ref,
    className: (0, _classnames.default)(className, prefix, variant ? `${prefix}--${variant}` : '', dismissible ? `${prefix}--dismissible` : ''),
    "data-analytics": analytics || `alert-modal-${variant}`,
    children: [
    // TODO: Variant should be required
    variant && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      size: "xs",
      type: variantIconMap[variant].icon,
      color: variantIconMap[variant].color,
      className: `${prefix}__icon`
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `${prefix}__content`,
      children: [
      //TODO: Heading should be required
      heading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
        type: "body-text-bold",
        className: `${prefix}__heading`,
        content: heading
      }), children, ((actions == null ? void 0 : actions.length) || timestamp) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `${prefix}__footer`,
        children: [actions && actions.map(({
          text,
          ...actionProps
        }, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: (0, _classnames.default)(`${prefix}__footer__item`, `${prefix}__footer__action`),
            ...actionProps,
            children: text
          }), (i < actions.length || timestamp) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: `${prefix}__footer__item`,
            children: "\xB7"
          })]
        })), timestamp && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: timestamp
        })]
      })]
    }), dismissible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseButton.default, {
      onClick: handleClose,
      "aria-label": closeLabel,
      analytics: props['data-analytics'] || 'close_alert'
    })]
  });
  if (!Transition) return show ? alert : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Transition, {
    unmountOnExit: true,
    ...props,
    ref: undefined,
    in: show,
    children: alert
  });
});
Alert.displayName = 'Alert';
Alert.defaultProps = defaultProps;
var _default = exports.default = Object.assign(Alert, {
  Link: AlertLink,
  Heading: AlertHeading
});
module.exports = exports.default;